import type { CanvasStore } from "domains/canvas/interfaces";

export async function exportStoreImage(
  store: CanvasStore,
  ignoreBackground = false
) {
  try {
    return await store.toDataURL({
      mimeType: "image/png",
      ignoreBackground: ignoreBackground,
      pixelRatio: 1,
      quality: 1,
    });
  } catch (error) {
    if (error instanceof Error) {
      // Ignore thoses errors because they happen when user remove element and delete canvas so we should not export
      if (error.message === "Export is failed. Can't find page container. true")
        return;
      if (error.message === "No page for export with id undefined") return;

      if (
        error.message.includes("Export is failed. Can not find stage for page")
      )
        return;
    }

    throw error;
  }
}
